/**
 * @todo 需要考虑的事项
 * 1. 扩展机制的设计
 * 2. 每个扩展事件的配置，drag 配置，参照 g-plugin-dragndrop
 */

import { DragNDrop } from './drag';
import { Gesture } from './gesture';

export { DragNDrop, Gesture };
export * from './interface';
